
















import { PaymentOptions } from "@/Model/checkout/cart/types";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CheckoutPaymentButton extends Vue {
  @(Prop(String)!) buttonLabel!: string;
  @(Prop(String)!) optionId!: PaymentOptions;

  @(Prop(String)!) activeOption!: PaymentOptions;

  onButtonClick() {
    this.$emit("onClick");
  }
}
